.bam-group-fields__image-container {
  width: 80px;

  @media screen and (min-width: 768px) {
    width: 96px;
  }

  @media screen and (min-width: 1024px) {
    width: 120px;
  }
}
